import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { apiRequest } from "utils/api";
import { DashboardRoutes } from "routes/DashboardRoutes";
import OnboardingRoutes from "routes/OnboardingRoutes";
import { PasswordRoutes } from "routes/PasswordRoutes";
import { AuthRoutes } from "routes/AuthRoutes";
import LoadingLogo from "routes/LoadingLogo";
import { AuthLayout } from "components/layout/AuthLayout";
import Update from "pages/Auth/Update";
import { AlertsContext } from "providers/alerts";

export function App() {
  const { loading, user } = useTenant();
  const location = useLocation();
  const [lastPage, setLastPage] = useState("");
  const { showError } = useContext(AlertsContext);

  useEffect(() => {
    const trackPageView = async () => {
      const { pathname } = location;

      if (lastPage !== pathname) {
        try {
          await apiRequest("/supabase/events/insert", {
            name: "page_loaded",
            data: {
              pathname,
            },
          });
          window.analytics.page();
        } catch (err) {
          console.error(err);
        } finally {
          setLastPage(pathname);
        }
      }
    };

    if (user) {
      trackPageView();
    }
  }, [location, user, lastPage]);

  useEffect(() => {
    let params = new URLSearchParams(location.hash);
    if (params.get("error_description")) {
      showError({
        title: "Invalid Link",
        description: params.get("error_description"),
      });
    }
  }, [location.hash, showError]);

  if (loading) {
    return <LoadingLogo />;
  }

  if (!user) {
    return (
      <AuthLayout>
        <AuthRoutes />
      </AuthLayout>
    );
  }

  // Update Password (Reset)
  if (location.pathname === "/update") {
    return (
      <AuthLayout>
        <Routes>
          <Route path="/update" element={<Update />} />
        </Routes>
      </AuthLayout>
    );
  }

  if (!user.metadata.password_set) {
    return (
      <AuthLayout>
        <PasswordRoutes />
      </AuthLayout>
    );
  }

  if (!user.metadata.onboarded) {
    return <OnboardingRoutes />;
  }

  return <DashboardRoutes />;
}
